<template>
    <div>
        <div class="ecran bloc col-lg-12">
            <h5>Formalités obtenues</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="4"><b>Type de permis: </b></b-col>

<!--                    <b-col style="float: left;" v-if="request.travaux_permis == 1" cols="12" lg="6">Permis de construire</b-col>-->
<!--                    <b-col style="float: left;" v-else-if="request.travaux_permis == 2" cols="12" lg="6">Permis de démolir</b-col>-->
<!--                    <b-col style="float: left;" v-else-if="request.travaux_permis == 3" cols="12" lg="6">Déclaration préalable</b-col>-->

                    <b-col style="float: left;" cols="12" lg="8">
                        <b-radio-group
                        v-model="request.travaux_permis"
                        :options="[{item: 1, name: 'Permis de construire'}, {item: 2, name: 'Permis de démolir'}, {item: 3, name: 'Déclaration préalable'}]"
                        :disabled="isDisabled"
                        value-field="item"
                        text-field="name"
                        >
                        </b-radio-group>
                    </b-col>


                    <b-col style="float: left;" cols="12" lg="6"><b>Numéro du permis: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_numero_dossier"></b-input></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Fermeture de rue: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.travaux_fermeture_rue"></b-checkbox></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Numéro de l'arrêté: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_arrete"></b-input></b-col>
                </b-row>
            </div>
        </div>
        <div class="ecran bloc col-lg-12">
            <h5>Travaux</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="6"><b>Nature des travaux: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_nature"></b-input></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Date de début: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6">
                        <b-form-datepicker hide-header :start-weekday="1" v-model="date_deb" :disabled="isDisabled && isHourDisabled" placeholder="Date de début" today-button today-button-variant="primary" label-help="" label-today-button="Aujourd'hui"></b-form-datepicker>
                    </b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Date de fin (incluse): </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6">
                        <b-form-datepicker hide-header :start-weekday="1" v-model="date_fin" :disabled="isDisabled && isHourDisabled" placeholder="Date de fin" today-button today-button-variant="primary" label-help="" label-today-button="Aujourd'hui"></b-form-datepicker>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="ecran bloc col-lg-12">
            <h5>Modalités</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="6"><b>Installation de matériel: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.travaux_installation_materiaux"></b-checkbox></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Palissade ou clôture de chantier: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.travaux_palissade"></b-checkbox></b-col>

                    <template v-if="request.travaux_palissade == 1">
                        <b-col style="float: left;" cols="12" lg="6"><b>Nombre de m²: </b></b-col>
                        <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_mesure_palissade"></b-input></b-col>
                    </template>

                    <b-col style="float: left;" cols="12" lg="6"><b>Nacelle - Grue: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.travaux_nacelle_grue"></b-checkbox></b-col>

                    <template v-if="request.travaux_nacelle_grue == 1">
                        <b-col style="float: left;" cols="12" lg="6"><b>Nombre de m²: </b></b-col>
                        <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_mesure_nacelle_grue"></b-input></b-col>
                    </template>

                    <b-col style="float: left;" cols="12" lg="6"><b>Benne: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.travaux_benne"></b-checkbox></b-col>

                    <template v-if="request.travaux_benne == 1">
                        <b-col style="float: left;" cols="12" lg="6"><b>Nombre de m²: </b></b-col>
                        <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_mesure_benne"></b-input></b-col>
                    </template>

                    <b-col style="float: left;" cols="12" lg="6"><b>Echafaudage: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.travaux_echaffaudage"></b-checkbox></b-col>

                    <template v-if="request.travaux_echaffaudage == 1">
                        <b-col style="float: left;" cols="12" lg="6"><b>Nombre de m²: </b></b-col>
                        <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_mesure_echaffaudage"></b-input></b-col>
                    </template>

                    <b-col style="float: left;" cols="12" lg="6"><b>Matériaux: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.travaux_materiaux"></b-checkbox></b-col>

                    <template v-if="request.travaux_materiaux == 1">
                        <b-col style="float: left;" cols="12" lg="6"><b>Nombre de m²: </b></b-col>
                        <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_mesure_materiaux"></b-input></b-col>
                    </template>

                    <b-col style="float: left;" cols="12" lg="6"><b>Autre: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.travaux_autre_travaux"></b-checkbox></b-col>

                    <template v-if="request.travaux_autre_travaux == 1">
                        <b-col style="float: left;" cols="12" lg="6"><b>Précision autre travaux: </b></b-col>
                        <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_autre_travaux_precision"></b-input></b-col>
                    </template>
                </b-row>
            </div>
        </div>
        <div class="ecran bloc col-lg-12">
            <h5>Stationnement d'un véhicule</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="6"><b>Stationnement: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.travaux_stationnement"></b-checkbox></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Immatriculation du véhicule: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.travaux_immatriculation"></b-input></b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Vuex from "vuex";

    export default {
        name: "Travaux",
        async mounted() {
            if(this.request.id == null && this.id != null)
                await this.getDemande({layername: 'odp_travaux', id: this.id});
        },
        props: ["id"],
        computed: {
            request: {
                get() {
                    return this.currentDemande;
                },
                set(value) {
                    this.setDemande(value);
                }
            },
            date_deb: {
                get() {
                    if(this.request.date_deb.indexOf('/') > -1)
                        return this.formatDate(this.request, 'date_deb')
                    else
                        return this.request.date_deb;
                },
                set(value) {
                    this.request.date_deb = value;
                }
            },
            date_fin: {
                get() {
                    if(this.request.date_fin.indexOf('/') > -1)
                        return this.formatDate(this.request, 'date_fin')
                    else
                        return this.request.date_fin;
                },
                set(value) {
                    this.request.date_fin = value;
                }
            },
            ...Vuex.mapGetters('Demande', ['currentDemande']),
            ...Vuex.mapGetters('Application', ['isHourDisabled', 'isDisabled'])
        },
        methods: {
            formatDetails(value) {
                return !!parseInt(value);
            },
            formatDate(value, row) {
                if(typeof value === 'undefined')
                    return "";
                else {
                    let date;
                    if(row == 'date_deb')
                        date = value.date_deb.split('/');
                    else if (row == 'date_fin')
                        date = value.date_fin.split('/');

                    date = date[2] + '-' + date[1] + '-' + date[0];
                    // console.log(date);
                    return date;
                }
            },
            ...Vuex.mapActions('Demande', ['getDemande', "setDemande"])
        }
    }
</script>

<style scoped>

</style>